module.exports = __webpack_public_path__ + "static/media/deepTerror.5bddf6a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/lib/monsterImages/deepTerror.png
// module id = 113
// module chunks = 0